/** Сохранения идут по очереди: следующее стартует после предыдущего, даже если то упало. */
export function enqueueSave<T>(queue: { current: Promise<void> }, run: () => Promise<T>): Promise<T> {
  const queued = queue.current.catch(() => undefined).then(run)
  queue.current = queued.then(
    () => undefined,
    () => undefined,
  )
  return queued
}
